import { withBase } from 'ufo'
import { articleSchema, articlesSchema } from '~/utils/crystallize/article'

const ROOT_PATH = '/artikler'

/**
 * Fetch a single article from the article catalogue. Will look for the article in the folder cache first and only fetch it if it is not found.
 *
 * @param slug - The article's slug in Crystallize.
 * @param rootPath - The root path of the article catalogue. Defaults to `/artikler`.
 */
export function useArticle(slug: MaybeRefOrGetter<string>, rootPath: MaybeRefOrGetter<string> = ROOT_PATH) {
  const path = computed(() => withBase(toValue(slug), toValue(rootPath)))

  const options = useCatalogueQueryOptions({ path, schema: articleSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}

export type CrystallizeArticle = VueQueryData<typeof useArticle>

/**
 * Fetch all articles from the article catalogue.
 */
export function useArticles(path = ROOT_PATH) {
  const options = useCatalogueQueryOptions({ path, schema: articlesSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
